import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import ArticleWarehouse from "../../../entities/productOrder/article/ArticleWarehouse";
import {ArticleWarehouseService} from "../../../service/ArticleWarehouseService";
import Pagination from "../../../entities/Pagination";


class ArticleWarehouseSelectStore {

    public loading: boolean;
    public commonStore: CommonStore;
    public filter?: string;
    public elements: ArticleWarehouse[];
    public pagination: Pagination;
    public selectedArticleWarehouse?: ArticleWarehouse;
    public isSearchDialogOpen: boolean;

    constructor(commonStore: CommonStore, selectedArticleWarehouse?: ArticleWarehouse) {
        this.loading = false;
        this.commonStore = commonStore;
        this.pagination = new Pagination(1, 15, 0, 0);
        this.elements = [];
        this.selectedArticleWarehouse = selectedArticleWarehouse;
        this.isSearchDialogOpen = false;
        makeAutoObservable(this);
    }

    @action
    public async search(): Promise<void> {
        this.loading = true;
        const response = await ArticleWarehouseService.get(1, 20, this.filter);
        if (response.success) {
            runInAction(() => {
                this.elements = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public toggleSearchDialog(value?: boolean) {
        value = (value === undefined) ? !this.isSearchDialogOpen : value;
        this.isSearchDialogOpen = value;
        if (this.isSearchDialogOpen) {
            this.search();
        }
    }

    get isEmpty(): boolean {
        return this.elements.length === 0;
    }

    @action
    public async setFilter(filter: string) {
        this.filter = filter;
        await this.search();
    }

    @action
    public setSelectedArticleWarehouse(articleWarehouse?: ArticleWarehouse) {
        this.selectedArticleWarehouse = articleWarehouse;
        this.isSearchDialogOpen = false;
    }

}

export default ArticleWarehouseSelectStore;
